import FieldDictionary from '@/classes/clientOnly/permissionTreeResources/dictionaries/fieldDictionary';
import {StatsFields} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/StatsFields';

export const statsFieldsDictionary: FieldDictionary<StatsFields> = [
    {
        text: 'Entwicklung der Einnahmen',
        readOnly: true,
        value: StatsFields.INCOME,
    },
    {
        text: 'Entwicklung der Schülerzahl',
        readOnly: true,
        value: StatsFields.NUMBER_OF_STUDENTS,
    },
    {
        text: 'Entwicklung der Schülerzahl nach Produktkategorie',
        readOnly: true,
        value: StatsFields.NUMBER_OF_STUDENTS_BY_PRODUCT_CATEGORY,
    },
    {
        text: 'Verbleibsdauer der Schüler:innen',
        readOnly: true,
        value: StatsFields.STUDENT_RETENTION,
    },
    {
        text: 'Verlauf je Kind (Karte „Verlauf“ im Schüler-Profil; zusammen mit Schüler lesen, Lehrkräfte sehen nur die Unterrichtsspur ihrer Kurse)',
        readOnly: true,
        value: StatsFields.STUDENT_TIMELINE,
    },
    {
        text: 'Verlauf je Kind: Nachrichten lesen (Text von Mails und WhatsApps des Kindes und seiner Eltern in der Karte „Verlauf“, auch aus Postfächern ohne Freigabe im Messenger; nur für Büro-Rollen, Lehrkräfte werden immer abgewiesen, jeder Zugriff wird protokolliert)',
        readOnly: true,
        value: StatsFields.STUDENT_TIMELINE_MESSAGES,
    },
    {
        text: 'Entwicklung der aktiven Standorte',
        readOnly: true,
        value: StatsFields.NUMBER_OF_ACTIVE_INSTITUTIONS,
    },
    {
        text: 'Rentabilität (Deckungsbeitrag je Kurs, Standort, Lehrkraft; zusammen mit „Entwicklung der Einnahmen“)',
        readOnly: true,
        value: StatsFields.UNPROFITABLE_COURSES,
    },
    {
        text: 'Lehrkräfte ohne Kurse',
        readOnly: true,
        value: StatsFields.TEACHERS_WITHOUT_COURSES,
    },
    {
        text: 'Standorte ohne Kurse',
        readOnly: true,
        value: StatsFields.INSTITUTIONS_WITHOUT_COURSES,
    },
    {
        text: 'Kündigungsquote je Lehrkraft (Schülermonate)',
        readOnly: true,
        value: StatsFields.TEACHER_CHURN,
    },
    {
        text: 'Mehr Abgänge als erwartet je Lehrkraft (nur Büro, Lehrkräfte sehen das nie)',
        readOnly: true,
        value: StatsFields.TEACHER_EXCESS,
    },
    {
        text: 'Kündigungen nach Produktkategorie',
        readOnly: true,
        value: StatsFields.TERMINATIONS_BY_PRODUCT_CATEGORY,
    },
    {
        text: 'Akquiseleistung der Mitarbeitenden',
        readOnly: true,
        value: StatsFields.EMPLOYEE_ACQUISITION_STATS,
    },
];
